module.exports = __webpack_public_path__ + "img/USA_CAKES_AND_PASTRIES.202c9033.png";